<template>
  <div class="marketing-container">
    <h1>Verifikasi Pengajuan Pinjaman</h1>
    <p>Daftar pengajuan pinjaman baru yang perlu diverifikasi.</p>

    <div v-if="loading">Memuat daftar...</div>
    <div v-if="error" class="error-message">{{ error }}</div>

    <div v-if="!loading && loans.length === 0 && !error">
      Tidak ada pengajuan pinjaman baru saat ini.
    </div>

    <table v-if="!loading && loans.length > 0">
      <thead>
        <tr>
          <th>ID Pinjaman</th>
          <th>Nama Nasabah</th>
          <th>No. Rekening</th>
          <th>Jumlah</th>
          <th>Tujuan</th>
          <th>Tgl Diajukan</th>
          <th>Aksi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="loan in loans" :key="loan.id">
          <td>{{ loan.id }}</td>
          <td>{{ loan.owner.full_name }}</td>
          <td>{{ loan.account.account_number }}</td>
          <td class="amount">Rp {{ formatCurrency(loan.amount) }}</td>
          <td>{{ loan.purpose }}</td>
          <td>{{ formatDateTime(loan.created_at) }}</td>
          <td class="actions">
            <!-- GANTI TOMBOL MENJADI LINK -->
            <router-link :to="{ name: 'LoanReview', params: { id: loan.id } }">
              <button class="review-btn">Review</button>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '@/services/api';


const loans = ref([]);
const loading = ref(true);
const error = ref(null);

const fetchLoansForVerification = async () => {
  loading.value = true;
  error.value = null;
  try {
    const response = await api.getLoansForVerification();
    loans.value = response.data;
  } catch (err) {
    console.error("Gagal mengambil data pinjaman:", err);
    error.value = "Tidak dapat memuat data. Pastikan Anda memiliki hak akses.";
  } finally {
    loading.value = false;
  }
};

// Fungsi bantuan
const formatCurrency = (value) => parseFloat(value).toLocaleString('id-ID');
const formatDateTime = (value) => new Date(value).toLocaleString('id-ID');

onMounted(() => {
  fetchLoansForVerification();
});
</script>

<style scoped>
  /* Anda bisa menyalin style dari SupervisorPage.vue karena mirip */
  table { width: 100%; border-collapse: collapse; margin-top: 20px; }
  th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
  th { background-color: #f2f2f2; }
  .actions button { margin-right: 5px; }
  .approve-btn { background-color: #007bff; color: white; border: none; padding: 5px 10px; cursor: pointer; }
  .reject-btn { background-color: #dc3545; color: white; border: none; padding: 5px 10px; cursor: pointer; }
  .amount { text-align: right; }
</style>